import { accessTokenKey } from '@const/localStorage';
import { useRootStore } from '@hooks/useRootStore';
import { Box, Button, Divider, Typography } from '@mui/material';
import { getLocalStorageItem } from '@utils/localStorageUtil';
import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface UserNotLoggedInProps {
    textColor?: string;
    showLoginButton?: boolean;
    showRegisterButton?: boolean;
}

const UserNotLoggedIn: React.FC<UserNotLoggedInProps> = observer(({ textColor = "inherit", showLoginButton = true, showRegisterButton = true }) => {
    var accesToken = getLocalStorageItem(accessTokenKey);
    const { authenticationStore, authorizationStore } = useRootStore();

    const { setIsLoginDrawerOpen } = authenticationStore;
    const { user } = authorizationStore;

    const navigate = useNavigate();

    useEffect(() => {

    }, [user])

    if (accesToken !== null) {
        return null;
    }

    return (
        <Box display={"flex"} flexDirection={"column"} gap={1} color={textColor}>
            {showLoginButton &&
                <Button
                    onClick={() => setIsLoginDrawerOpen(true)}
                    size='medium'
                    variant='contained'
                    color='secondary'
                    sx={{
                        mb: 2
                    }}>
                    <Typography>Prijavi se</Typography>
                </Button>
            }

            {showRegisterButton &&
                <>
                    <Divider>Novi si na Naručku? Registriraj se.</Divider>
                    <Button
                        onClick={() => navigate('/registration')}
                        size='medium'
                        variant='outlined'
                        color='primary'>
                        <Typography color={textColor}>Registriraj se</Typography>
                    </Button>
                </>
            }
        </Box >
    )
})

export default UserNotLoggedIn;